/** Encode Jira links for storage — keeps projectKey even when no tickets selected. */
export function encodeJiraLinksPayload(projectKey, links) {
  const list = Array.isArray(links) ? links : [];
  const key = String(projectKey || "").trim();
  if (!key && list.length === 0) return null;
  if (!key) return JSON.stringify(list);
  return JSON.stringify({ projectKey: key, links: list });
}

/** Parse stored Jira links — supports legacy array, object, or single URL. */
export function parseJiraLinksPayload(raw) {
  if (!raw) return { projectKey: "", links: [] };
  try {
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) {
      const links = parsed.filter((l) => l && l.key);
      const projectKey = links[0]?.key ? String(links[0].key).split("-")[0] : "";
      return { projectKey, links };
    }
    if (parsed && typeof parsed === "object") {
      const links = Array.isArray(parsed.links) ? parsed.links.filter((l) => l && l.key) : [];
      const projectKey = String(parsed.projectKey || "").trim()
        || (links[0]?.key ? String(links[0].key).split("-")[0] : "");
      return { projectKey, links };
    }
  } catch (_) { /* ignore */ }
  const m = String(raw).match(/\/browse\/([A-Z]+-\d+)/i);
  if (m) {
    const issueKey = m[1].toUpperCase();
    return { projectKey: issueKey.split("-")[0], links: [{ key: issueKey, url: raw }] };
  }
  return { projectKey: "", links: [] };
}

export function parseJiraLinks(raw) {
  return parseJiraLinksPayload(raw).links;
}
